import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import PhoneInput from 'react-phone-input-2';
import { COUNTRY_CURRENCY_CODES } from 'src/commons/currency';
import ImagePicker from '../imagePicker';
import { useEffect, useState } from 'react';

const GymForm = ({
  errors,
  handleBlur,
  handleChange,
  handleSubmit,
  isSubmitting,
  touched,
  values,
  heading = '',
  handleCloseModal,
  setFieldValue,
  logo
}) => {
  const [imageFile, setImageFile] = useState(null);

  useEffect(() => {
    if (logo) {
      setImageFile(logo);
    }
  }, [logo]);
  return (
    <form onSubmit={handleSubmit}>
      <Box sx={{ mb: 3, display: 'flex', justifyContent: 'space-between' }}>
        <Typography color="textPrimary" variant="h2">
          {heading}
        </Typography>
        {handleCloseModal && (
          <CloseIcon sx={{ cursor: 'pointer' }} onClick={handleCloseModal} />
        )}
      </Box>

      <TextField
        error={Boolean(touched.name && errors.name)}
        fullWidth
        helperText={touched.name && errors.name}
        label="Name"
        margin="normal"
        name="name"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.name}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.address && errors.address)}
        fullWidth
        helperText={touched.address && errors.address}
        label="Address"
        margin="normal"
        name="address"
        onBlur={handleBlur}
        onChange={handleChange}
        type="text"
        value={values.address}
        variant="outlined"
      />
      <TextField
        error={Boolean(touched.email && errors.email)}
        fullWidth
        helperText={touched.email && errors.email}
        label="Email"
        margin="normal"
        name="email"
        onBlur={handleBlur}
        onChange={handleChange}
        type="email"
        value={values.email}
        variant="outlined"
      />

      <Box sx={{ marginBottom: '8px' }}>
        <PhoneInput
          country={'us'}
          placeholder="Mobile Number"
          inputStyle={{
            height: '3.5rem',
            width: '100%',
            border:
              touched.phone && errors?.phone
                ? '1px solid red'
                : '1px solid rgba(0, 0, 0, 0.23)',
            marginTop: '16px'
          }}
          buttonClass={
            touched.phone && errors?.phone ? 'errorDropdown' : 'flagDropdown'
          }
          value={values?.phone}
          name="phone"
          onChange={(value, country) => {
            setFieldValue('phone', value);
            setFieldValue('callingCode', `+${country?.dialCode}`);
          }}
          inputProps={{
            required: true
          }}
          searchPlaceholder="Search"
          enableSearch
          countryCodeEditable={false}
        />
        {touched?.phone && errors?.phone && (
          <p
            style={{
              color: 'red',
              fontFamily: 'Roboto',
              fontSize: '0.8rem',
              marginLeft: '15px',
              marginTop: '5px'
            }}
          >
            {errors?.phone}
          </p>
        )}
      </Box>
      <FormControl
        variant="outlined"
        fullWidth
        margin="normal"
        id="currency-select"
      >
        <InputLabel id="currency-label">{'Select Currency'}</InputLabel>
        <Select
          error={Boolean(touched.currency && errors.currency)}
          value={values.currency}
          onChange={handleChange}
          labelId="currency-label"
          id="currency"
          label="Select currency"
          name="currency"
        >
          {COUNTRY_CURRENCY_CODES?.map((currency, index) => (
            <MenuItem key={index} name="currency" value={currency?.code}>
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <Typography
                  sx={{ marginRight: 3 }}
                >{`(${currency.symbol})`}</Typography>
                <Typography>{currency.code}</Typography>
              </div>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {/* <Autocomplete
        id="country-select-demo"
        sx={{
          width: '100%',
          marginTop: '16px',
          marginBottom: '8px'
        }}
        options={COUNTRY_CURRENCY_CODES}
        autoHighlight
        name="currency"
        required
        getOptionLabel={(option) => option.code}
        onInputChange={(e, value) => setFieldValue('currency', value)}
        inputProps={{ sx: { backgroundColor: 'white' } }}
        containerClass="inputStyle"
        renderOption={(props, option) => {
          const { key, ...optionProps } = props;
          return (
            <Box
              key={key}
              component="li"
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                width: '100%'
              }}
              {...optionProps}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  width: '100%'
                }}
              >
                <Typography
                  sx={{ marginRight: 3 }}
                >{`(${option.symbol})`}</Typography>
                <Typography>{option.code}</Typography>
              </div>
            </Box>
          );
        }}
        renderInput={(params) => (
          <TextField
            label="Currency"
            required
            name="currency"
            error={Boolean(touched?.currency && errors.currency)}
            helperText={touched?.currency && errors.currency}
            fullWidth
            variant="outlined"
            {...params}
            slotProps={{
              htmlInput: {
                ...params.inputProps,
                autoComplete: 'new-password'
              }
            }}
          />
        )}
      /> */}
      <TextField
        error={Boolean(touched.logo && errors.logo)}
        fullWidth
        helperText={touched.logo && errors.logo}
        label="Logo"
        InputLabelProps={{
          shrink: true
        }}
        margin="normal"
        id="logo"
        name="logo"
        onBlur={handleBlur}
        inputProps={{
          accept: 'image/*'
        }}
        onChange={(event) => {
          setFieldValue('logo', event?.currentTarget?.files[0]);
          const file = event?.currentTarget?.files[0];
          if (!file) {
            setImageFile(null);
            return;
          }
          const fileImage = new FileReader();
          fileImage.readAsDataURL(file);
          fileImage.onload = () => {
            setImageFile(fileImage.result);
          };
        }}
        type="file"
        variant="outlined"
      />

      <ImagePicker pickedImage={imageFile} setImage={setImageFile} />

      <Box sx={{ py: 2 }}>
        <Button
          color="primary"
          disabled={isSubmitting}
          fullWidth
          size="large"
          type="submit"
          variant="contained"
        >
          {heading}
        </Button>
      </Box>
    </form>
  );
};

export default GymForm;
